var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.88889H13M5.5 6.77778V11.1111M8.5 6.77778V11.1111M1.75 3.88889L2.5 12.5556C2.5 12.9386 2.65804 13.306 2.93934 13.5769C3.22064 13.8478 3.60218 14 4 14H10C10.3978 14 10.7794 13.8478 11.0607 13.5769C11.342 13.306 11.5 12.9386 11.5 12.5556L12.25 3.88889M4.75 3.88889V1.72222C4.75 1.53068 4.82902 1.34698 4.96967 1.21153C5.11032 1.07609 5.30109 1 5.5 1H8.5C8.69891 1 8.88968 1.07609 9.03033 1.21153C9.17098 1.34698 9.25 1.53068 9.25 1.72222V3.88889",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.364408158cb4a0e427e147723cd32756.svg";
export { ForwardRef as ReactComponent };